import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-invalid-link',
  templateUrl: './invalid-link.component.html'
})
export class InvalidLinkComponent {
  @HostBinding('class')
  private classes = 'font-main inline-flex flex-col gap-4 items-center justify-center';
}
